import React, {Component} from 'react';
import Link from 'next/link';
import styles from "../profileNavBarTab/profileNavBarTab.module.scss";
import {observer} from "mobx-react";

class ProfileNavBarTab extends Component<any, any> {
  props: {
    isActive?: boolean;
    disabled?: boolean;
    link?: string;
    label?: string;
    index?: number;
    notification?: number
  }

  render() {
    const divClass = this.props.isActive ? styles.active : styles.profileNavDivs;
    const link = !this.props.disabled ? this.props.link : '';
    const style = this.props.notification ? {marginRight: "50px"} : {};
    return (
      <Link href={link}>
        {
          //@ts-ignore
          <div className={divClass} disabled={this.props.disabled} index={this.props.index} style={style}>
            <span>{this.props.label}</span>
            {
              !!this.props.notification &&
              <div className={styles.notification}><span>{this.props.notification}</span></div>
            }
          </div>}
      </Link>
    )
  }
}

export default observer(ProfileNavBarTab)
